import { Option, OptionString } from "../../../interfaces/interfaces";
import { LanguageVersions, MenuTypes } from "../../../interfaces/meMenuInterfaces/interfaces";
import { MultiOption } from "@services/ui-components/src/MultiSelect/MultiSelect";
import { getMenuTypeEnumOptionsBySlug } from "./menuEnumMappings";
import { TFunction } from "i18next";

export const getMenuTypeOptions = (menuTypes: MenuTypes[], t: TFunction): Option[] => {
    return (
        menuTypes?.map((menuType) => ({
            value: menuType.id,
            label: t(menuType.name),
        })) || []
    );
};

export const getMenuTypeEnumOptions = (menuTypes: MenuTypes[], getLabel?: (name: string) => string): OptionString[] => {
    return getMenuTypeEnumOptionsBySlug(menuTypes, getLabel);
};

export const getLanguageVersionOptions = (languageVersions: LanguageVersions[]): MultiOption[] => {
    return (
        languageVersions?.map((languageVersion) => ({
            value: languageVersion.id,
            label: languageVersion.name,
        })) || []
    );
};
